<div class="product-conditions">
  <div class="product-condition">
    <div class="product-condition-title"> Total prizes: </div>
    <div class="product-condition-description">
      <img src="/assets/svg-icons/total-prizes.svg" alt="total prizes" />
      <div class="product-condition-value">
        {{ product.instant_win_count + product.prize_count | number: '1.0-0' }}
      </div>
    </div>
  </div>
  <div class="product-condition">
    <div class="product-condition-title"> Total value: </div>
    <div class="product-condition-description">
      <img src="/assets/svg-icons/total-value-bill.svg" alt="total value" />
      <div class="product-condition-value">
        {{ product.prize_value | currency: currency : 'symbol' }}
      </div>
    </div>
  </div>
</div>
